import enviro from 'enviro';
export const INTEGRATION_STATUS_CONNECTED = 'CONNECTED';
const LINKED_IN_SALES_NAVIGATOR_APP_ID = 42082;
const QA_LINKED_IN_SALES_NAVIGATOR_APP_ID = 1161054;
export function getLinkedInSalesNavigatorId() {
  return enviro.isProd() ? LINKED_IN_SALES_NAVIGATOR_APP_ID : QA_LINKED_IN_SALES_NAVIGATOR_APP_ID;
}